import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Text,
  View,
  Image,
  TextInput,
  TouchableOpacity,
  ImageBackground,
} from "react-native";
import { SUCCESS } from "../../constants/statusCode";
import styles from "../../styles/operatorLoginStyles";
import apis from "../../services/api-services";
import { SERVER_ERROR, SESSION_TOKEN } from "../../constants/textConstants";
import { encrypt } from "../../utils/encryption";
import { OPERATOR_PATH } from "../../constants/routePaths";
import HocComponent from "../../commonComponents/Hoc";
import ReCAPTCHA from 'react-google-recaptcha-enterprise'

class OperatorLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: "",
      password: "",
      recaptchaResponse: "",
      loginDisable: true,
    };
    this.handleCaptchaResponseChange = this.handleCaptchaResponseChange.bind(this);
  }

  // onclick Login Button this method is called.
  loginUser = () => {
    this.setState({
      loginDisable: true,
    });
    if (!this.state.userName || !this.state.password || !this.state.recaptchaResponse) {
      this.setState({
        loginDisable: false,
        recaptchaResponse: "",
      });
      return;
    }
    apis.user
      .loginUser({
        userId: this.state.userName,
        password: this.state.password,
        captchaToken: this.state.recaptchaResponse
      })
      .then((data) => {
        this.setState({
          loginDisable: false,
          recaptchaResponse: "",
        });
        if (data.status === SUCCESS) {
          localStorage.setItem(SESSION_TOKEN, encrypt(data.token));

          this.props.history.push({
            pathname: OPERATOR_PATH,
          });
        } else if (data.message) {
          alert(data.message);
        } else alert(SERVER_ERROR);
      })
      .catch((error) => {
        console.log(error);
        alert(error || SERVER_ERROR);
        this.setState({
          loginDisable: false,
          recaptchaResponse: "",
        });
        this.recaptcha.reset();
      });

  };
  handleCaptchaResponseChange(response) {
    this.setState({
      recaptchaResponse: response,
      loginDisable: false,
    });
  }
  // onload Login page this method is called to clear the storage.
  componentDidMount() {
    if (localStorage.getItem(SESSION_TOKEN)) {
      this.props.history.push({
        pathname: OPERATOR_PATH,
      });
    }
  }

  render() {
    const loginContainerResponsive = `loginContainer_${this.props.measure}`;
    const loginViewRes = `loginView_${this.props.measure}`;
    const resTextInput = `TextInput_${this.props.measure}`;
    const rescontainerForInput = `containerForInput_${this.props.measure}`;
    const resloginBtn = `loginBtn_${this.props.measure}`;
    return (
      <ImageBackground
        style={styles.container}
        source={require("../../../assets/images/background.jpg")}
      >
        <Image
          style={styles.logo}
          source={require("../../../assets/images/logo.png")}
        ></Image>

        <View style={[styles.loginContainer, styles[loginContainerResponsive]]}>
          <View style={[styles.loginView, styles[loginViewRes]]}>
            <View style={styles.header}>
              <Image
                style={styles.support}
                source={require("../../../assets/images/operator.png")}
              ></Image>
              <Text style={styles.headerText}>Operator Login</Text>
            </View>
            <View style={styles.inputField}>
              <Text style={styles.idText}>Operator ID</Text>
            </View>
            <View
              style={[styles.containerForInput, styles[rescontainerForInput]]}
            >
              <TextInput
                style={[
                  styles.TextInput,
                  { outline: "none" },
                  styles[resTextInput],
                ]}
                placeholder="Enter your ID"
                placeholderTextColor="#d6d6d6"
                onChangeText={(userName) =>
                  this.setState({
                    userName,
                  })
                }
              />
            </View>
            <View style={styles.inputField}>
              <Text style={styles.passwordText}>Password</Text>
            </View>

            <View
              style={[styles.containerForInput, styles[rescontainerForInput]]}
            >
              <TextInput
                autoCompleteType="off"
                style={[
                  styles.TextInput,
                  { outline: "none" },
                  styles[resTextInput],
                ]}
                placeholder="Enter your Password"
                secureTextEntry={true}
                placeholderTextColor="#d6d6d6"
                onChangeText={(password) =>
                  this.setState({
                    password,
                  })
                }
              />
            </View>

            <ReCAPTCHA
              ref={(el) => { this.recaptcha = el; }}
              sitekey={process.env.RECAPTCHA_SITE_KEY}
              onChange={this.handleCaptchaResponseChange}
            />

            <TouchableOpacity
              style={[styles.loginBtn, styles[resloginBtn]]}
              onPress={() => {
                this.loginUser();
              }}
              disabled={this.state.loginDisable}
            >
              <Text style={styles.loginText}>LOGIN</Text>
            </TouchableOpacity>
          </View>
        </View>
      </ImageBackground>
    );
  }
}
export default HocComponent(withRouter(OperatorLogin));
